import React, { useContext, useEffect, useRef, useState } from "react"
import { Audio } from "../../../interfaces/Page"
import ReactPlayer from "react-player"
import { AudioDuration, AudioPlayer, AudioTitle } from "./styles"
import PlayIcon from "./PlayIcon"
import { PlayerContext } from "../../store/PlayerContext"

type Props = {
  track: Audio
  color?: string
  specialColor?: string
}

const Track: React.FC<Props> = ({
  track,
  color,
  specialColor,
}): JSX.Element => {
  const [player, setPlayer] = useState({
    duration: 0,
    playing: false,
  })
  const playerRef = useRef<null | ReactPlayer>(null)
  const playerContext = useContext(PlayerContext)
  const url = track.url ? track.url : track.file

  useEffect(() => {
    if (playerContext.player.playing && playerContext.player.url === url) {
      setPlayer({
        ...player,
        playing: true,
      })
    } else if (
      !playerContext.player.playing &&
      playerContext.player.url === url
    ) {
      setPlayer({
        ...player,
        playing: false,
      })
    } else if (playerContext.player.url != url) {
      setPlayer({
        ...player,
        playing: false,
      })
      // if (playerRef?.current && typeof playerRef?.current?.seekTo === 'function') {
      //   playerRef?.current?.seekTo(0, "seconds")
      // }
    }
  }, [playerContext.player.playing, playerContext.player.url])

  useEffect(() => {
    if (
      playerContext.player.url === url &&
      playerRef.current != null &&
      playerContext.player.updateProgress.amount
    ) {
      playerRef.current.seekTo(
        playerContext.player.updateProgress.amount,
        playerContext.player.updateProgress.type
      )
    }
  }, [playerContext.player.updateProgress])

  return (
    <div>
      <ReactPlayer
        ref={playerRef}
        volume={1}
        width={0}
        height={0}
        progressInterval={200}
        playing={player.playing}
        onReady={x => {
          setPlayer({
            ...player,
            duration: x?.getDuration() ? x.getDuration() : 0,
          })

          if (url === playerContext.player.url) {
            playerContext.setPlayerContext({
              type: "SET_PLAYER",
              payload: {
                duration: x?.getDuration() ? x.getDuration() : 0,
              },
            })
          }
        }}
        onProgress={progress => {
          if (progress?.played) {
            ////console.log(progress)
            playerContext.setPlayerContext({
              type: "SET_PLAYER",
              payload: {
                progress: progress.played,
              },
            })
          }
        }}
        onPlay={() => {

          playerContext.setPlayerContext({
            type: "SET_PLAYER",
            payload: {
              title: track.title,
              url: url,
              playing: player.playing,
              duration: player.duration,
              description: track.description,
            },
          })
        }}
        onPause={() => {
          if (url === playerContext.player.url) {
            playerContext.setPlayerContext({
              type: "SET_PLAYER",
              payload: {
                url: url,
                playing: player.playing,
                duration: player.duration,
              },
            })
          } else {
            if (playerRef.current != null) {
              playerRef.current.seekTo(0, "seconds")
            }
          }
        }}
        onEnded={() => {
          playerContext.setPlayerContext({
            type: "SET_PLAYER",
            payload: {
              url: url,
              playing: player.playing,
              duration: player.duration,
            },
          })
        }}
        url={url}
      />

      <AudioPlayer>
        <PlayIcon
          control={() => {
            setPlayer({ ...player, playing: !player.playing })
          }}
          play={player.playing}
          specialColor={specialColor}
        ></PlayIcon>
        <p>
          <AudioTitle color={color}>{track.title}</AudioTitle>
          <AudioDuration color={specialColor}>
            {new Date(player.duration * 1000)
              .toISOString()
              .substr(11, 8)
              .replace(/.*(\d{2}:)(\d{2}:\d{2}).*/, "$2")}
          </AudioDuration>
        </p>
      </AudioPlayer>
    </div>
  )
}

export default Track
